module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__box-subtitle04-4f53fa9d1e1cd144cff8b4df12e2db35.png";